import type { ReactNode } from 'react';

/**
 * L'intestazione, su OGNI pagina — accesso compreso.
 *
 * Mutuata dalla landing (`am-landing/src/styles/chrome.css`), nella sua
 * variante `is-solid`: 72px, wordmark alto 30px, filo di separazione, fondo a
 * vetro. Sulla landing lo stato vetro arriva con lo scroll perché lì sotto
 * c'è un hero scuro; qui il fondo è bianco da subito, quindi lo stato è
 * quello fisso — la stessa scelta che la landing fa per le sue pagine chiare.
 *
 * Il logo c'è anche sulla schermata di accesso, e non è decorazione: chi apre
 * un link ricevuto per email deve poter riconoscere dove sta atterrando prima
 * di scriverci l'indirizzo istituzionale. Una pagina di login senza marchio è
 * indistinguibile da una pagina di login copiata.
 *
 * `children` è il lato destro: nella console le due schede e l'uscita;
 * sull'accesso non c'è niente, perché non c'è ancora niente da dire. Chi sta
 * parlando e per conto di chi lo dice la fascia sotto (`Layout`), non questa:
 * qui c'è il prodotto, lì l'identità della sessione.
 */
export function SiteHeader({ children }: { children?: ReactNode }) {
  return (
    <header className="sticky top-0 z-20 border-b border-border bg-background/85 backdrop-blur-md backdrop-saturate-150">
      <div className="mx-auto flex h-[72px] max-w-3xl items-center gap-3 px-5 sm:gap-4">
        <a href="/" className="flex shrink-0 items-center" aria-label="AllertaMeteo">
          {/* 30px come sulla landing, ma non sotto i 640px: lì il wordmark
              disteso più le due schede più «esci» sforano i 375px, e la pagina
              prende uno scroll orizzontale che non si vede finché non ci si
              trova col bottone di uscita mezzo fuori dallo schermo. */}
          <img
            src="/assets/logo-allertameteo.png"
            alt="AllertaMeteo"
            width={602}
            height={91}
            className="h-[24px] w-auto sm:h-[30px]"
          />
        </a>
        {children}
      </div>
    </header>
  );
}
